import { useInsuranceApi } from 'apps/wrapper/src/hooks/use-insurance-api';
import { useLocations } from 'apps/wrapper/src/hooks/use-locations';
import { SessionStatusMessage } from 'apps/wrapper/src/types/kayn/session-status-message';
import { FC, useCallback, useEffect, useState } from 'react';
import { DashboardContainer, Message, Spinner } from './dashboard.styles';

export const Dashboard: FC = () => {
  const { selectedLocation } = useLocations();
  const { getKaynDashboardUrl, status } = useInsuranceApi();
  const [dashboardUrl, setDashboardUrl] = useState<string | null>(null);
  const [isIframeLoading, setIsIframeLoading] = useState(true);

  const refreshIframe = useCallback(async () => {
    if (!selectedLocation) return;

    setIsIframeLoading(true);
    const result = await getKaynDashboardUrl(selectedLocation.id);
    setDashboardUrl(result?.url ?? null);
  }, [selectedLocation]);

  useEffect(() => {
    if (!selectedLocation) return;

    setDashboardUrl(null);
    setIsIframeLoading(true);
    refreshIframe();

    const handler = (event: MessageEvent) => {
      const data = event.data as SessionStatusMessage | undefined;
      if (!data || data.type !== 'session-status') return;

      const { isActive, error } = data;

      if (error || !isActive) {
        refreshIframe();
        return;
      }
    };

    window.addEventListener('message', handler);
    return () => window.removeEventListener('message', handler);
  }, [selectedLocation]);

  return (
    <DashboardContainer>
      {(status.getKaynDashboardUrl.isRunning || isIframeLoading) && !status.getKaynDashboardUrl.error && <Spinner />}
      {!status.getKaynDashboardUrl.isRunning && status.getKaynDashboardUrl.error && (
        <Message text="Error loading insurance dashboard" />
      )}
      {!status.getKaynDashboardUrl.isRunning && dashboardUrl && (
        <iframe
          title="Insurance Dashboard"
          src={dashboardUrl}
          style={{
            width: isIframeLoading ? 0 : '100%',
            height: isIframeLoading ? 0 : 'calc(100vh - 80px)',
            border: 'none',
            visibility: isIframeLoading ? 'hidden' : 'visible'
          }}
          onLoad={() => setIsIframeLoading(false)}
        />
      )}
    </DashboardContainer>
  );
};
